export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'https://devtrackforce.ibos.io'
    : window.location.origin;
// export const BASE_URL ='https://app.trackforce.io'